import React from "react";
import PropTypes from "prop-types";
import Button from "./Button";
import Tooltip from "./Tooltip";
import * as types from "../../constants/ComponentConstants";
import { Popup } from 'semantic-ui-react';

const Form = (props) => {
	const byline = props.byline
		? <span className="byline">{props.byline}</span>
		: null;

	const leftWrapperStyle = { "float": "left", "marginRight": ".83333%" };

	const tooltipLeftButton = props.tooltipLeftButton
		? <Tooltip
			text={props.tooltipLeftButton}
			tooltipType={types.TOOLTIP_INFO}
			windowWidth={props.tooltipWindowWidthLeftButton}
		/>
		: null;

	const leftButton = props.leftButtonLabel
		? <div style={leftWrapperStyle}><Button onClick={props.onLeftButtonClick} text={props.leftButtonLabel} disabled={props.leftButtonDisabled} className="c-button--left" />{tooltipLeftButton}</div>
		: null;

	const leftButton2 = props.leftButton2Label
		? <Button onClick={props.onLeftButton2Click} text={props.leftButton2Label} disabled={props.leftButton2Disabled} className="c-button--cancel c-button--left" />
		: null;

	const rightButton = props.rightButtonLabel
		? <Button onClick={props.onRightButtonClick} text={props.rightButtonLabel} disabled={props.rightButtonDisabled} className="c-button--right" style={{ 'float': 'right' }} />
		: null;

	const undoButtonStyle = { 'width': '75px', 'minWidth': '0px' };
	const undoWrapperStyle = { "float": "left" };

	const undoButton = props.onUndoButtonClick && (props.undoButtonVisible == "true" || props.undoButtonVisible === true)
		? <Popup wide="very" position="top left" content="Keer terug naar de vorige situatie" trigger={<div style={undoWrapperStyle}><Button className="c-button--left" onClick={props.onUndoButtonClick} text={'\u27f2'} style={undoButtonStyle} /></div>} />
		: null;

	const isNotRequired = props.isNotRequired
		? null
		: <div className="is-required"><p>Alle velden zijn verplicht tenzij anders aangegeven</p></div>;

	const error = props.error
		? <div className="c-form__notifications error u-clear">
			<p className="o-col-12">
				<i className="fa fa-fw fa-exclamation-circle"></i>{props.error}
			</p>
		</div>
		: null;

	const tooltip = props.tooltip
		? <Tooltip
			text={props.tooltip}
			tooltipType={types.TOOLTIP_INFO}
			windowWidth={props.tooltipWindowWidth}
			windowAlignRight={props.tooltipWindowAlignRight}
		/>
		: null;

	return (
		<form className="c-form" name={props.name} autoComplete="off" onSubmit={e => { e.preventDefault(); }}>
			{props.headerVisible ? <div className="c-form__header">
				<div className="title">
					<h2>{props.title}{tooltip}</h2>
					{byline}
				</div>
				{isNotRequired}
			</div> : ""}

			<div className={"c-form__body"}>
				{error}
				{props.children}
			</div>
			<div className={"c-form__actions"}>
				{leftButton}
				{leftButton2}
				{undoButton}
				{rightButton}
			</div>
		</form>
	);
};

Form.propTypes = {
	name: PropTypes.string.isRequired,
	title: PropTypes.string,
	tooltip: PropTypes.string,
	tooltipWindowWidth: PropTypes.number,
	tooltipWindowAlignRight: PropTypes.bool,
	byline: PropTypes.string,
	leftButtonLabel: PropTypes.string,
	leftButtonDisabled: PropTypes.bool,
	onLeftButtonClick: PropTypes.func,
	leftButton2Label: PropTypes.string,
	leftButton2Disabled: PropTypes.bool,
	onLeftButton2Click: PropTypes.func,
	rightButtonLabel: PropTypes.string,
	rightButtonDisabled: PropTypes.bool,
	onRightButtonClick: PropTypes.func,
	isNotRequired: PropTypes.bool,
	headerVisible: PropTypes.bool,
	error: PropTypes.string,
	children: PropTypes.node,
	tooltipLeftButton: PropTypes.string,
	tooltipWindowWidthLeftButton: PropTypes.number,
	onUndoButtonClick: PropTypes.func,
	undoButtonVisible: PropTypes.bool
};

Form.defaultProps = {
	headerVisible: true
};

export default Form;
